<script>
  import Chart from 'chart.js'
  export default {
    name: 'RoiChart',

    props: {
      'chart-data': Object
    },

    data() {
      return {
        chartType: 0, // 0, 1, 2, 3

        lineChart: null,
        lineChartData: null,

        barChart: null,
        barChartData: null,

        doughnutChart: null,
        doughnutChartData: null

      };
    },
    created() {
      this.updateLineData()
      this.updateBarData()
      this.updateDoughnutData()
    },

    mounted() {
      var ctx = document.getElementById('canvas').getContext('2d');
      var ctx1 = document.getElementById('canvas1').getContext('2d');
      var ctx2 = document.getElementById('canvas2').getContext('2d');

      this.barChart = new Chart(ctx, this.barChartData)
      this.lineChart = new Chart(ctx1, this.lineChartData)
      this.doughnutChart = new Chart(ctx2, this.doughnutChartData)
    },


    computed: {
      chart() {
        return JSON.parse(JSON.stringify(this.chartData))
      },
    },
    methods: {
      updateLineData() {
        if (this.lineChartData == null)
          this.lineChartData = this.chart.lineChart

        this.lineChartData['data']['datasets'] = [this.chart.lineChartData[this.chartType]]

        if (this.lineChart != null)
          this.lineChart.update()
      },
      updateBarData() {
        if (this.barChartData == null)
          this.barChartData = this.chart.barChart

        this.barChartData['data']['datasets'] = [this.chart.barChartData[this.chartType]]

        if (this.barChart != null)
          this.barChart.update()
      },
      updateDoughnutData(){
        if(this.doughnutChartData == null)
            this.doughnutChartData = this.chart.doughnutChart

        this.doughnutChartData['data']['datasets'] = [this.chart.doughnutChartData[this.chartType]]

        if(this.doughnutChart != null)
            this.doughnutChart.update()
      },
      changeType(type = null) {
        if(type == null)
            this.chartType = (this.chartType + 1) % 4
        else
            this.chartType = type

        this.updateLineData()
        this.updateBarData()
        this.updateDoughnutData()
      }
    },
  };
</script>

<template>
  <div class="mt-2">
    <div class="row my-3">
        <button type="button" class="btn btn-primary btn-sm col mx-2" @click="changeType(0)">%Loss</button>
        <button type="button" class="btn btn-primary btn-sm col mx-2" @click="changeType(1)">Bushels Lost</button>
        <button type="button" class="btn btn-primary btn-sm col mx-2" @click="changeType(2)">$(USD) Lost</button>
        <button type="button" class="btn btn-primary btn-sm col mx-2" @click="changeType(3)">$(USD) Lost Per Acre</button>
    </div>
    <div class="row">
      <div class="col">
        <div id="container" style="height: 800px;">
          <canvas id="canvas"></canvas>
        </div>
      </div>
      <div class="col">
        <div id="container1" style="">
          <canvas id="canvas1"></canvas>
        </div>
        <div id="container2" style="height: 550px;">
          <canvas id="canvas2"></canvas>
        </div>

      </div>
    </div>

  </div>
</template>


// WEBPACK FOOTER //
// resources/assets/js/components/ResearchCharts.vue